import { Flame } from "lucide-react";
import { useTranslation } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useTranslation();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="marquee"
      className="marquee relative w-full overflow-hidden border-y border-orange-500/25 bg-gradient-to-r from-orange-600/15 via-orange-500/10 to-orange-600/15"
    >
      <div className="absolute left-0 top-0 bottom-0 z-10 flex items-center gap-2 px-4 bg-gradient-to-r from-orange-500 to-orange-600 text-black font-bold tracking-widest text-xs">
        <Flame className="w-4 h-4" /> HOT
      </div>
      <div className="marquee-track flex gap-12 whitespace-nowrap py-3 pl-24 pr-6 text-sm text-orange-100/90">
        {items.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-orange-400" />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
